import { deleteTaskFilter } from '@dispatch/shared/services';
import { useMutation } from 'react-query';

export const useDeleteTaskFilter = (userId: string, onSuccess: () => void) => {
  const { mutate, error, status } = useMutation(
    ['delete-filter', userId],
    async (filterId: string) => deleteTaskFilter(userId, filterId),
    {
      onSuccess,
    }
  );

  return {
    deleteTaskFilter: mutate,
    error,
    status,
  };
};
